'use client';

import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { pushGtmEvent } from '@/app/utils/gtm';

const ScheduleDemoModal = dynamic(
    () => import('@/components/demos/ScheduleDemoModal').then((m) => m.ScheduleDemoModal),
    { ssr: false }
);

const DemoModalContext = createContext(null);

export function DemoModalProvider({ children }) {
    const [isScheduleOpen, setIsScheduleOpen] = useState(false);

    const openScheduleModal = useCallback((source) => {
        setIsScheduleOpen(true);
        pushGtmEvent('demo_form_open', { source: source || 'unknown' });
    }, []);
    const closeScheduleModal = useCallback(() => setIsScheduleOpen(false), []);

    const value = useMemo(
        () => ({ openScheduleModal, closeScheduleModal }),
        [openScheduleModal, closeScheduleModal]
    );

    return (
        <DemoModalContext.Provider value={value}>
            {children}
            {isScheduleOpen && <ScheduleDemoModal onClose={closeScheduleModal} />}
        </DemoModalContext.Provider>
    );
}

export function useDemoModal() {
    const ctx = useContext(DemoModalContext);
    if (!ctx) {
        throw new Error('useDemoModal must be used within a DemoModalProvider');
    }
    return ctx;
}
